// This file is generated/updated by scripts/set-sentry-release.js during CI builds.
// It is safe to commit with an empty release for local development.
export const SENTRY_RELEASE = "cafler-frontend@0.0.1+7127a58";
